import {
  formDataRequest,
  getRequest,
  postRequest,
} from "../libs/AxiosService.util";

export async function serviceCreatePreferredPartner(params) {
  return await formDataRequest("preferred/partners/create", params);
}
export async function serviceUpdatePreferredPartner(params) {
  return await formDataRequest("preferred/partners/update", params);
}
export async function serviceGetPreferredPartnerDetails(params) {
  return await postRequest("preferred/partners/detail", params);
}
export async function serviceGetPreferredPartners(params) {
  return await postRequest("preferred/partners", params);
}
export async function serviceAddManageBanner(params) {
  return await formDataRequest("preferred/partners/banner/add", params);
}
export async function serviceGetBanners(params) {
  return await formDataRequest("preferred/partners/banner", params);
}

export async function serviceCreatePreferredPartnerTypes(params) {
  return await formDataRequest("preferred/partners/type/create", params);
}
export async function serviceUpdatePreferredPartnerTypes(params) {
  return await formDataRequest("preferred/partners/type/update", params);
}
export async function serviceGetPreferredPartnerTypesDetails(params) {
  return await postRequest("preferred/partners/type/detail", params);
}
export async function serviceGetPreferredPartnerTypes(params) {
  return await postRequest("preferred/partners/type", params);
}